// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file deeplink/deeplink_response.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { ChatError_ChatIsUnavailable } from '../chat/chat_errors_pb';
import { file_chat_chat_errors } from '../chat/chat_errors_pb';
import type { PersonalizedChat } from '../chat/chat_model_pb';
import { file_chat_chat_model } from '../chat/chat_model_pb';
import type {
  MessageError_ChatTypeIsNotApplicable,
  MessageError_MessageDoesNotExist,
  MessageError_UnsupportedPayloadType,
} from '../message/message_errors_pb';
import { file_message_message_errors } from '../message/message_errors_pb';
import type { DeepLink } from './deeplink_model_pb';
import { file_deeplink_deeplink_model } from './deeplink_model_pb';

/**
 * Describes the file deeplink/deeplink_response.proto.
 */
export const file_deeplink_deeplink_response: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CiBkZWVwbGluay9kZWVwbGlua19yZXNwb25zZS5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiWgoTR2V0RGVlcExpbmtSZXNwb25zZRI7CgdzdWNjZXNzGAEgASgLMiguY29tLmdlbS5iZmYuY29udHJhY3QuR2V0RGVlcExpbmtTdWNjZXNzSABCBgoEdHlwZSJKChJHZXREZWVwTGlua1N1Y2Nlc3MSNAoMZGVlcExpbmtEYXRhGAEgASgLMh4uY29tLmdlbS5iZmYuY29udHJhY3QuRGVlcExpbmsiYwoeUmVmcmVzaERlZXBMaW5rRGV0YWlsc1Jlc3BvbnNlEjkKB3N1Y2Nlc3MYASABKAsyJi5jb20uZ2VtLmJmZi5jb250cmFjdC5QZXJzb25hbGl6ZWRDaGF0SABCBgoEdHlwZSLRAwodQ3JlYXRlTWVzc2FnZURlZXBMaW5rUmVzcG9uc2USRQoHc3VjY2VzcxgBIAEoCzIyLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNyZWF0ZU1lc3NhZ2VEZWVwTGlua1N1Y2Nlc3NIABJOChFjaGF0SXNVbmF2YWlsYWJsZRgCIAEoCzIxLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNoYXRFcnJvci5DaGF0SXNVbmF2YWlsYWJsZUgAElUKE21lc3NhZ2VEb2VzTm90RXhpc3QYAyABKAsyNi5jb20uZ2VtLmJmZi5jb250cmFjdC5NZXNzYWdlRXJyb3IuTWVzc2FnZURvZXNOb3RFeGlzdEgAEl0KF2NoYXRUeXBlSXNOb3RBcHBsaWNhYmxlGAQgASgLMjouY29tLmdlbS5iZmYuY29udHJhY3QuTWVzc2FnZUVycm9yLkNoYXRUeXBlSXNOb3RBcHBsaWNhYmxlSAASWwoWdW5zdXBwb3J0ZWRQYXlsb2FkVHlwZRgFIAEoCzI5LmNvbS5nZW0uYmZmLmNvbnRyYWN0Lk1lc3NhZ2VFcnJvci5VbnN1cHBvcnRlZFBheWxvYWRUeXBlSABCBgoEdHlwZSIwChxDcmVhdGVNZXNzYWdlRGVlcExpbmtTdWNjZXNzEhAKCGRlZXBMaW5rGAEgASgJQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw',
    [
      file_deeplink_deeplink_model,
      file_chat_chat_model,
      file_message_message_errors,
      file_chat_chat_errors,
    ]
  );

/**
 * @generated from message com.gem.bff.contract.GetDeepLinkResponse
 */
export type GetDeepLinkResponse = Message<'com.gem.bff.contract.GetDeepLinkResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetDeepLinkResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetDeepLinkSuccess success = 1;
         */
        value: GetDeepLinkSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetDeepLinkResponse.
 * Use `create(GetDeepLinkResponseSchema)` to create a new message.
 */
export const GetDeepLinkResponseSchema: GenMessage<GetDeepLinkResponse> =
  /*@__PURE__*/
  messageDesc(file_deeplink_deeplink_response, 0);

/**
 * @generated from message com.gem.bff.contract.GetDeepLinkSuccess
 */
export type GetDeepLinkSuccess = Message<'com.gem.bff.contract.GetDeepLinkSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.DeepLink deepLinkData = 1;
   */
  deepLinkData?: DeepLink;
};

/**
 * Describes the message com.gem.bff.contract.GetDeepLinkSuccess.
 * Use `create(GetDeepLinkSuccessSchema)` to create a new message.
 */
export const GetDeepLinkSuccessSchema: GenMessage<GetDeepLinkSuccess> =
  /*@__PURE__*/
  messageDesc(file_deeplink_deeplink_response, 1);

/**
 * @generated from message com.gem.bff.contract.RefreshDeepLinkDetailsResponse
 */
export type RefreshDeepLinkDetailsResponse =
  Message<'com.gem.bff.contract.RefreshDeepLinkDetailsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.RefreshDeepLinkDetailsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.PersonalizedChat success = 1;
           */
          value: PersonalizedChat;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.RefreshDeepLinkDetailsResponse.
 * Use `create(RefreshDeepLinkDetailsResponseSchema)` to create a new message.
 */
export const RefreshDeepLinkDetailsResponseSchema: GenMessage<RefreshDeepLinkDetailsResponse> =
  /*@__PURE__*/
  messageDesc(file_deeplink_deeplink_response, 2);

/**
 * @generated from message com.gem.bff.contract.CreateMessageDeepLinkResponse
 */
export type CreateMessageDeepLinkResponse =
  Message<'com.gem.bff.contract.CreateMessageDeepLinkResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.CreateMessageDeepLinkResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.CreateMessageDeepLinkSuccess success = 1;
           */
          value: CreateMessageDeepLinkSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.MessageError.MessageDoesNotExist messageDoesNotExist = 3;
           */
          value: MessageError_MessageDoesNotExist;
          case: 'messageDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.MessageError.ChatTypeIsNotApplicable chatTypeIsNotApplicable = 4;
           */
          value: MessageError_ChatTypeIsNotApplicable;
          case: 'chatTypeIsNotApplicable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.MessageError.UnsupportedPayloadType unsupportedPayloadType = 5;
           */
          value: MessageError_UnsupportedPayloadType;
          case: 'unsupportedPayloadType';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.CreateMessageDeepLinkResponse.
 * Use `create(CreateMessageDeepLinkResponseSchema)` to create a new message.
 */
export const CreateMessageDeepLinkResponseSchema: GenMessage<CreateMessageDeepLinkResponse> =
  /*@__PURE__*/
  messageDesc(file_deeplink_deeplink_response, 3);

/**
 * @generated from message com.gem.bff.contract.CreateMessageDeepLinkSuccess
 */
export type CreateMessageDeepLinkSuccess =
  Message<'com.gem.bff.contract.CreateMessageDeepLinkSuccess'> & {
    /**
     * @generated from field: string deepLink = 1;
     */
    deepLink: string;
  };

/**
 * Describes the message com.gem.bff.contract.CreateMessageDeepLinkSuccess.
 * Use `create(CreateMessageDeepLinkSuccessSchema)` to create a new message.
 */
export const CreateMessageDeepLinkSuccessSchema: GenMessage<CreateMessageDeepLinkSuccess> =
  /*@__PURE__*/
  messageDesc(file_deeplink_deeplink_response, 4);
